import { formatDate } from '@fullcalendar/core'

const classDates = [
	'08-29',
	'08-31',
	'09-02',
	'09-05',
	'09-07',
	'09-09',
	'09-12',
	'09-14',
	'09-16',
	// '09-19',		// Covid days
	// '09-21',
	'09-23',
	'09-26',
	'09-28',
	'09-30',
	'10-03',
	'10-05',
	'10-07',
	'10-12',
	'10-14',
	'10-17',
	'10-19',
	'10-21',
	'10-24',
	'10-26',
	'10-28',
	'10-31',
	'11-02',
	'11-04',
	'11-07',
	'11-09',
	'11-11',
	'11-14',
	'11-16',
	'11-18',
	'11-21',
	'11-28',
	'11-30',
	'12-02',
	'12-05',
	'12-07',
	'12-09'
].map(x=>'2022-'+x);



const examPeriod = [
	'12-12',
	'12-13',
	'12-14',
	'12-15',
	'12-16'
].map(x=>'2022-'+x);

const breakDays = [
	'10-08',
	'10-09',
	'10-10',
	'10-11',
	'11-23',
	'11-24',
	'11-25',
	'11-26',
	'11-27'
].map(x=>'2022-'+x);



const problemSetsAssigned = [
	'09-21', //after first Clarity class
	'10-13',   //after first Applications class
	'11-10',  // after first Updating class
	'12-02'  // after final class
].map(x=>'2022-'+x);

const problemSetsDue = [
	'09-26',  // five days later
	'10-19',
	'11-14',
	'12-08'
].map(x=>'2022-'+x+'T17:00');

const dialoguesDue = [
	'10-05',
	'11-16'							// was 11-09, gave extension
].map(x=>'2022-'+x+'T17:00');

const classesCancelled = [
	'02-05'
].map(x=>'2021-'+x);

const linkto = (x,y) => `<a href="${y}"><i>${x}</i></a>`

const modules = [
	{title: "Introduction",
	extendedtitle: "",
	readings: [	
		[]
		],
	slides: [
		false
		]
	},
	{title: "What is Science?",
	extendedtitle: "Week 1: What is Science?",
	readings: [
		[	`Godfrey-Smith, Chapter 1`]
		],
	slides: [
		`01-Intro`
		]
	},
	{title: "The Scout Mindset",
	extendedtitle: "",
	readings: [
		[	`Galef, Introduction and Part I`]
		],
	handout: [`Galef-Part-I`]
	},
	{title: "Popper",
	extendedtitle: "Week 2: Karl Popper on Falsification and Demarcation",
	readings: [
		[	`Godfrey-Smith, Chapter 4`],
		[]
		],
	slides: [
		`02-Popper-1`,
		`03-Popper-2`
		]
	},
	{title: "The Scout Mindset",
	extendedtitle: "",
	readings: [
		[	`Galef, Part II`]
		],
	handout: [`Galef-Part-II`]
	},
	{title: "Kuhn",
	extendedtitle: "Week 3: Thomas Kuhn on Paradigms and Normal Science",
	readings: [
		[	`Godfrey-Smith, Chapter 5 and 6`],
		[]
		],
	slides: [
		`04-Kuhn-1`,
		`05-Kuhn-2`
		]
	},
	{title: "The Scout Mindset",
	extendedtitle: "",
	readings: [
		[	`Galef, Part III`]
		],
	handout: [`Galef-Part-III`]
	},
	// {title: "Lakatos",
	// extendedtitle: "Week 4: Lakatos, Feyerabend, and Frameworks",
	// readings: [
	// 	[	`Godfrey-Smith, Chapter 7`],
	// 	[]
	// 	],
	// slides: [
	// 	`06-Frameworks-1`,
	// 	`07-Frameworks-2`
	// 	]
	// },     Forced to move these for covid reasons
	{title: "The Scout Mindset",
	extendedtitle: "",
	readings: [
		[	`Galef, Part IV`]
		],
	handout: [`Galef-Part-IV`]
	},
	{title: "Lakatos",
	extendedtitle: "Week 4: Lakatos, Feyerabend, and Frameworks",
	readings: [
		[	`Godfrey-Smith, Chapter 7`],
		[]
		],
	slides: [
		`06-Frameworks-1`,
		`07-Frameworks-2`
		]
	},
	{title: "The Scout Mindset",
	extendedtitle: "",
	readings: [
		[	`Galef, Part V`]
		],
	handout: [[`Galef-Part-V`]]
	},
	{title: "Sociology",
	extendedtitle: "Week 5: The Sociology of Science",
	readings: [
		[	`Godfrey-Smith, Chapters 8 and 9.1-9.4`],
		[]
		],
	slides: [
		`08-Sociology-1`,
		`09-Sociology-2`
		]
	},
	

	{title: "Academic Fraud",
	extendedtitle: "",
	readings: [
		[	`Liam Kofi Bright, ${linkto("Why Do Scientists Lie?", "/assets/WhyLie.pdf")}`]
		],
	handout: [[`Fraud`]]
	},
	{title: "Practice",
	extendedtitle: "Week 6: The Norms of Responsible Research Practice",
	readings: [
		[`The National Academies, ${linkto("On Being a Scientist", "/assets/OnBeingaScientist.pdf")}`]
		],
	slides: [
		`10-Guidelines-1`
		]
	},
	
	{title: "The Knowledge Machine",
	extendedtitle: "",
	readings: [
		[	`Strevens, Intro and Part I`]
		],
	handout: [[`Strevens-Part-I`]]
	},


	{title: "Practice",
	extendedtitle: "Week 6: The Norms of Responsible Research Practice",
	readings: [
		[`The National Academies, ${linkto("On Being a Scientist", "/assets/OnBeingaScientist.pdf")}`],
		[]
		],
	slides: [
		`11-Guidelines-2`,
		`12-Guidelines-3`
		]
	},
	// {title: "Realism",
	// extendedtitle: "Week 7: Scientific Realism and Objectivity", 
	// readings: [
	// 	[`Godfrey-Smith, Chapter 12`]
	// 	],
	// slides: [
	// 	false,
	// 	false
	// 	]
	// },

	
	{title: "The Knowledge Machine",
	extendedtitle: "",
	readings: [
		[	`Strevens, Part II`]
		],
	slides: [`Strevens-II-Handout`]
	},
	{title: "Realism and Explanation",
	extendedtitle: "Week 8: Realism and Explanation", 
	readings: [
		[`Godfrey-Smith, Chapters 12 and 13`],
		[]
		],
	slides: [
		`13-Realism-I`,
		`14-Realism-Explanation`
		]
	},
	// {title: "Confirmation",															Deleted for Covid reasons.  Wouldn't have gone well anyway.
	// extendedtitle: "Week 9: Induction and Confirmation", 
	// readings: [
	// 	[`Godfrey-Smith, Chapter 3`],
	// 	[]
	// 	],
	// slides: [
	// 	false,
	// 	false
	// 	]
	// },
		{title: "The Knowledge Machine",
	extendedtitle: "",
	readings: [
		[	`Strevens, Part III`]
		],
	handout: [[`Strevens-Part-III`]]
	},

	{title: "Bayesianism",
	extendedtitle: "Week 10: The Bayesian Revolution", 
	readings: [
		[`Godfrey-Smith, Chapter 14`],
		[]
		],
	slides: [
		`15-Explanation`,
		`16-Stats`
		]
	},
	{title: "The Knowledge Machine",
	extendedtitle: "",
	readings: [
		[	`Strevens, Part IV`]
		],
	handout: [`Strevens-Part-IV`]
	},

	{title: "Limitations",
	extendedtitle: "Week 11: The Limits of Science", 
	readings: [
		[`Godfrey-Smith, Chapter 15`],
		[],
		[`Susan Blackmore, ${linkto("What Is It Like?", "/assets/BlackmoreWIIL.pdf")}`]
		],
	slides: [
		`17-Unity-1`,
		`18-Ethics-1`,
		false
		],
	handout: [,,`Blackmore`]
	},
	{title: "AI",
	extendedtitle: "Special Topics: Artificial Intelligence", 
	readings: [
		[`Daniel Dennett, ${linkto("Can Machines Think?", "/assets/DennettCMT.pdf")}`],
		[],
		[],
		[],
		[]
		],
	slides: [
		`19-AI-1`,
		`20-AI-2`,
		`21-AI-3`,
		`22-AI-4`,
		`23-AI-5`
		],
	},
	{title: "Presentations",
	extendedtitle: "Student Presentations", 
	readings: [
		[],
		[],
		[],
		[],
		[]
		]
	},




	// {title: "Explanation",
	// extendedtitle: "Explanation", 
	// readings: [
	// 	[`Godfrey-Smith, Chapter 13`],
	// 	[]
	// 	[`Strevens, Part II`]
	// 	]
	// },

	// {title: "Confirmation",
	// extendedtitle: "Induction and Confirmation",
	// readings: [
	// 	[`Godfrey-Smith, Chapter 3`],
	// 	[]
	// 	[`Strevens, Part III`]
	// 	]
	// },

	// {title: "Bayesianism",
	// extendedtitle: "The Bayesian Revolution", 
	// readings: [
	// 	[`Godfrey-Smith, Chapter 14`],
	// 	[]
	// 	[`Strevens, Part IV`]
	// 	]
	// },




	// read this for next time: https://cosmosmagazine.com/biology/how-the-octopus-got-its-smarts/
	// https://mymodernmet.com/wu-yung-sen-blackwater-photography/



];


const buildModuleDates = () => {
	let currClass = 0;
	const moduleDates = [];
	for (let i=0; i<modules.length; i++) {
		for (let j=0; j<modules[i].readings.length; j++) {
			moduleDates.push({
				title: modules[i].title,
				extendedtitle: modules[i].extendedtitle ? modules[i].extendedtitle : "",
				start: classDates[currClass],
				readings: modules[i].readings[j],
				modulelength: modules[i].readings.length,
				firstinmodule: !j,
				slides: modules[i].slides ? modules[i].slides[j] : null,
				handout: modules[i].handout ? modules[i].handout[j] : null
			})
			currClass++;
		}
	}
	return moduleDates;
}


const moduleEvents = buildModuleDates();
const dialogueEvents = dialoguesDue.map((x,i)=>({title: `Book Review ${i+1} due`, start: x	}))
const problemSetsAssignedEvents = problemSetsAssigned.map((x,i)=>({title:`Problem Set ${i+1}`, start: x}))
const problemSetsDueEvents = problemSetsDue.map((x,i)=>({title:`Problem Set ${i+1} Due`, start: x}))
const problemSetEvents = problemSetsAssigned.map((x,i)=>({title:`Problem Set ${i+1} Available`, start: x, end: problemSetsDue[i]}))
const breakDayEvents = breakDays.map((x,i)=>({title:"Break Day", start: x}));
const examEvents = examPeriod.map((x,i)=>({title:"Exams", start: x}));
const cancelledEvents = classesCancelled.map((x,i)=>({title:"Class cancelled", start: x}));

export { classDates, moduleEvents, breakDayEvents, problemSetsAssignedEvents, problemSetsDueEvents, dialogueEvents, examEvents, cancelledEvents, problemSetEvents };